// extracted by mini-css-extract-plugin
export var currencyInput = "_kp-1";
export var currencySymbol = "_kp-0";